import {
    ClientRegistration, ConfigSettings, CurrencySettings, LicenseSettings, LocationComponentSettings, MapSettings,
    SettingsRegistry
} from "@mcleod/core";
import { LMEGeneralSettings } from "./LMEGeneralSettings";
import { MarketInsightSettings } from "./MarketInsightSettings";
import { LMECompanySettings } from "./LMECompanySettings";
import { LMEUserSettings } from "./LMEUserSettings";

export class LMESettingsInitializer {
    public initialize() {
        const settingsRegistry = SettingsRegistry.get();
        settingsRegistry.register(
            new ConfigSettings(),
            new CurrencySettings(),
            new LicenseSettings(),
            new LMECompanySettings(),
            new LMEGeneralSettings(),
            new LMEUserSettings(),
            new LocationComponentSettings(),
            new MapSettings(),
            new MarketInsightSettings()
        );
        settingsRegistry.settingsRoot = "lme/";
        settingsRegistry.authSettingsBodyProvider = ClientRegistration.getAuthSettingsBody;
    }
}
